import React from "react";
import { Typography, ErrorLabel } from "components";
import { colors } from "styles/colors";

import {
  Header,
  HeaderBorderAfter,
  HeaderBorderBefore,
  HeaderTitle,
  MainContainer,
} from "./BoxWithLabel.css";

interface BoxWithLabelProps {
  label: string;
  children: React.ReactNode;
  error: string | undefined;
}

export const BoxWithLabel = ({ children, label, error }: BoxWithLabelProps) => {
  return (
    <>
      <MainContainer error={!!error}>
        <Header>
          <HeaderBorderBefore error={!!error} />
          <HeaderTitle>
            <Typography variant="label" {...(error && { color: colors.error })}>
              {label}
            </Typography>
          </HeaderTitle>
          <HeaderBorderAfter error={!!error} />
        </Header>

        {children}
      </MainContainer>
      {error && <ErrorLabel message={error} />}
    </>
  );
};
